
import Vue from 'vue';
import { Label, VForm } from '@/model';
import ColorPicker from '@/components/ColorPicker.vue';

export default Vue.extend({
  name: 'LabelEditor',
  components: { ColorPicker },

  props: {
    value: { type: Object as () => Label | undefined, required: false },
  },

  data() {
    return {
      loading: false,
      editItem: this.value ? { ...this.value } : { id: 0 },
    };
  },

  watch: {
    value(label) {
      this.editItem = label ? { ...label } : { id: 0 };
    },
  },

  computed: {
    editForm(): VForm {
      return this.$refs.editForm as VForm;
    },
  },

  methods: {
    validate() {
      if (this.editForm.validate()) {
        return this.editItem;
      }
      return undefined;
    },
  },

});
